import {
  UpdateAttestationOptionPayload,
  UpdateAttestationStepPayload,
  UpdateAttestationTextPayload
} from './attestationView.types';

export enum ActionType {
  UPDATE_OPTION = 'UPDATE_OPTION',
  UPDATE_STEP = 'UPDATE_STEP',
  UPDATE_TEXT = 'UPDATE_TEXT'
}

export const updateAttestationOption = (payload: UpdateAttestationOptionPayload) =>
  ({
    payload,
    type: ActionType.UPDATE_OPTION
  } as const);

export const updateAttestationStep = (payload: UpdateAttestationStepPayload) =>
  ({
    payload,
    type: ActionType.UPDATE_STEP
  } as const);

export const updateAttestationText = (payload: UpdateAttestationTextPayload) =>
  ({
    payload,
    type: ActionType.UPDATE_TEXT
  } as const);

export type Action =
  | ReturnType<typeof updateAttestationOption>
  | ReturnType<typeof updateAttestationStep>
  | ReturnType<typeof updateAttestationText>;
